import {CSSProperties, FC} from 'react';


export interface IIconLightsLowProps {
    className?: string;
    color?: string;
    size?: string;
    style?: CSSProperties;
}

export const IconLightsLow: FC<IIconLightsLowProps> = (props) => {
    const {
        className,
        color,
        size,
        style = {},
    } = props;

    /* eslint-disable max-len */
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            className={className}
            fill="currentColor"
            width="1em"
            height="1em"
            style={{
                display: 'inline-block',
                flexShrink: 0,
                color,
                fontSize: size,
                lineHeight: '1em',
                ...style,
            }}
        >
            <path fillRule="evenodd" d="M13.5 3a.75.75 0 0 1 .738.615l.076.42c.915 5.157.914 10.55 0 15.934l-.076.415A.75.75 0 0 1 13.5 21C7.726 21 3 17 3 12c0-5.001 4.726-9 10.5-9Zm-9 9c0 3.938 3.674 7.213 8.374 7.482.834-5.056.835-10.12.002-14.964C8.175 4.786 4.5 8.06 4.5 12Zm15.364-1.607-3.75-2.25a.75.75 0 1 1 .772-1.286l3.75 2.25a.75.75 0 1 1-.772 1.286Zm.772 3.213-3.75-2.25a.75.75 0 0 0-.772 1.287l3.75 2.25a.75.75 0 1 0 .772-1.287Zm-3.75 2.25 3.75 2.25a.75.75 0 1 1-.772 1.287l-3.75-2.25a.75.75 0 1 1 .772-1.287Z" clipRule="evenodd" />
        </svg>
    );
};
